import React from 'react';
import { motion } from 'framer-motion';
import ModernHeader from '../../components/modern/ModernHeader';
import ModernFooter from '../../components/modern/ModernFooter';
import SEO from '../../components/modern/SEO';

export default function ModernImpreszum() {
  return (
    <>
      <SEO 
        title="Impresszum - XL bútor"
        description="XL bútor impresszum és kapcsolati információk. Cégadatok, székhely, elérhetőségek."
      />
      
      <div className="bg-[var(--color-bg)]">
        <ModernHeader />
        
        <main>
          {/* Hero Section */}
          <section className="relative py-20 md:py-28 bg-gradient-to-br from-[var(--color-text-primary)] to-gray-800">
            <div className="mx-auto max-w-[var(--container-max)] px-4 text-center">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <h1 className="text-4xl md:text-5xl font-[var(--font-serif)] font-semibold text-white mb-6 tracking-tight">
                  Impresszum
                </h1>
                <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto">
                  Szolgáltatói információk és elérhetőségek
                </p>
              </motion.div>
            </div>
          </section>

          {/* Content Section */}
          <section className="py-16 md:py-24 bg-white">
            <div className="mx-auto max-w-[900px] px-4">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="space-y-12"
              >
                {/* Szolgáltató adatai */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-6">
                    Szolgáltató adatai
                  </h2>
                  <div className="bg-[var(--color-bg)] rounded-2xl p-8 shadow-[var(--shadow-subtle)]">
                    <div className="space-y-4">
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                        <span className="font-semibold text-[var(--color-text-primary)] min-w-[140px]">Cég neve:</span>
                        <span className="text-[var(--color-text-secondary)]">XL Bútor és Szőnyeg</span>
                      </div>
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                        <span className="font-semibold text-[var(--color-text-primary)] min-w-[140px]">Székhely:</span>
                        <span className="text-[var(--color-text-secondary)]">4600 Kisvárda, Attila u. 61.</span>
                      </div>
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                        <span className="font-semibold text-[var(--color-text-primary)] min-w-[140px]">E-mail:</span>
                        <a href="mailto:xlbutorbolt@gmail.com" className="text-[var(--color-accent)] hover:underline">
                          xlbutorbolt@gmail.com
                        </a>
                      </div>
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                        <span className="font-semibold text-[var(--color-text-primary)] min-w-[140px]">Telefon:</span>
                        <a href="tel:06704179210" className="text-[var(--color-accent)] hover:underline">
                          06 (70) 417 9210
                        </a>
                      </div>
                      <div className="flex flex-col sm:flex-row sm:items-start gap-2">
                        <span className="font-semibold text-[var(--color-text-primary)] min-w-[140px]">Nyitvatartás:</span>
                        <span className="text-[var(--color-text-secondary)]">
                          Hétfő-Péntek: 9:00-17:00<br />
                          Szombat: 8:00-13:00
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tevékenységi kör */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    Tevékenységi kör
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    Bútorok és szőnyegek kiskereskedelme, lakberendezési tanácsadás, egyedi bútorkészítés.
                  </p>
                </div>

                {/* Weboldal működtetése */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    Weboldal működtetése
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    Ez a weboldal információs célokat szolgál, ahol bemutatjuk termékeinket és szolgáltatásainkat. 
                    A weboldal tartalma tájékoztató jellegű, nem minősül ajánlattételnek.
                  </p>
                </div>

                {/* Szerzői jogok */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    Szerzői jogok
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    A weboldalon található szövegek, képek, logók és egyéb tartalmak szerzői jogi védelem alatt állnak. 
                    Tartalmak másolása, terjesztése csak előzetes írásos engedéllyel lehetséges.
                  </p>
                </div>

                {/* Felelősség kizárása */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    Felelősség kizárása
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    A weboldal tartalmának pontosságáért minden erőfeszítést megteszünk, azonban nem vállalunk felelősséget 
                    a tartalomban esetlegesen előforduló hibákért vagy hiányosságokért.
                  </p>
                </div>

                {/* Harmadik felek linkjei */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    Harmadik felek linkjei
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    Weboldalunkon található külső linkek csak tájékoztató jellegűek. A külső weboldalak tartalmáért 
                    nem vállalunk felelősséget.
                  </p>
                </div>

                {/* Jogszabályok */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    Jogszabályok
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    Weboldalunk használata a magyar jogszabályoknak megfelelően történik. 
                    Minden jogi vitában a magyar bíróságok illetékesek.
                  </p>
                </div>

                {/* Utolsó módosítás */}
                <div className="pt-8 border-t border-gray-200">
                  <p className="text-sm text-[var(--color-text-secondary)]">
                    <strong>Utolsó módosítás:</strong> {new Date().getFullYear()}. {new Date().toLocaleDateString('hu-HU', { month: 'long' })}
                  </p>
                </div>
              </motion.div>
            </div>
          </section>
        </main>
        
        <ModernFooter />
      </div>
    </>
  );
}

